var _defs, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinimalStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "minimalStar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.32 18.52a1.406 1.406 0 011.36 0l4.075 2.253a.562.562 0 00.827-.583l-.801-4.91c-.072-.44.07-.889.381-1.208l3.407-3.492a.562.562 0 00-.318-.949l-4.18-.638a2.25 2.25 0 01-1.697-1.268l-1.865-3.973a.563.563 0 00-1.018 0l-2.375 5.06-5.367.82a.562.562 0 00-.318.948l3.407 3.492c.311.32.453.768.381 1.208l-.8 4.91a.562.562 0 00.826.583l4.075-2.252z",
    fill: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: "50%",
    fill: "#d8d8d8",
    width: "100%",
    height: "100%",
    mask: "url(#minimalStar_svg__a)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    mask: "url(#minimalStar_svg__a)"
  })));
}
export default SvgMinimalStar;